import Common from '@/utils/common'

// 查询账户余额
export function getAccountBalancd(data) {
  return Common.createRequest('customer-api', 'customer_account_balance', data)
}
// 查询结算信息
export function getSettleAmount(data) {
  return Common.createRequest('report-api', 'APP_MER_PROD_TRANS', data)
}
// 查询开发接入及支持
export function getIcon(data) {
  return Common.createRequest('dict-api', 'FILE_QUERY_PAGE', data)
}
// 查询帐户明细
export function getAccount(data) {
  return Common.createRequest('capital-api', 'MER_ACC_FLOW_SEARCH', data)
}
// 查看协议
export function DetailData(data) {
  return Common.createRequest('dict-api', 'FILE_DETAIL_QUERY', data)
}
// 查询账务流水交易类型和子交易类型
export function getAccTradeCode(data) {
  return Common.createRequest('capital-api', 'ACC_TRADE_CODE_SEARCH', data)
}
// 通过key查找value值
export function getValueByKey(key, vpCollection) {
  // console.log(key);
  // console.log(vpCollection);
  var myC = vpCollection.filter((p) => {
    return p.key === key
  })
  // console.log(myC);
  if (myC.length !== 0) {
    return myC[0].display_name
  } else {
    return key
  }
}

// 查询结算信息
export function queryOrderTotalNum(data) {
  return Common.createRequest('order-api', 'ORDER_QUERY_TOTAL_NUM', data)
}
export function statDetailExport(data) {
  return Common.createDownRequest('capital-api', 'MER_ACC_FLOW_SEARCH_DOWNLOAD', data)
}

// 下载流调溯源数据
export function surveyExport(data) {
  return Common.createDownRequest('order-api', 'MERCHANT_STREAM_CALL_TRACE_ORDER_DOWNLOAD', data)
}